// dependencies
import React from "react";

import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

// report analytics store
import useStore from "../../../pages/Report/store/index";

import { FieldCategory } from "../../../schemas/report";

// config
import Config from "../Config";

interface BaseProps {
	onChange: (value: any) => void;
	fieldCategory: FieldCategory;
	value: unknown;
	isDisabled: boolean;
}

const ConfiguredFieldPicker = (props: BaseProps) => {
	const { onChange, value, isDisabled, fieldCategory } = props;
	const [availableGridColumns] = useStore((state) => [state.availableGridColumns]);
	const availableGridColumnsReviewFields = availableGridColumns.filter(
		(column) => column.fieldType === "REVIEW_FIELD"
	);
	const availableGridColumnNames = availableGridColumnsReviewFields.map((column) => column.field);

	const fieldsForCategory = Config.categoryOptions.find((cat) => cat.value === fieldCategory)?.fields;
	let filteredFieldsForCategory = fieldsForCategory;

	if (!availableGridColumnNames.includes("Review Participants")) {
		filteredFieldsForCategory = fieldsForCategory?.filter((field) => field._id !== "participants");
	}

	const formattedOptions =
		filteredFieldsForCategory
			?.map((field) => ({
				value: field._id,
				label: field.name,
				type: field.type,
			}))
			// sort by label alphabetically
			.sort((a, b) => (a.label > b.label ? 1 : -1)) ?? [];

	return (
		<SelectInput
			results={formattedOptions}
			name={fieldCategory}
			onChange={onChange}
			value={value as Result}
			disabled={isDisabled}
		/>
	);
};

export default ConfiguredFieldPicker;
